export type UserSession = {
  id: string;
  email: string;
  nama?: string;
  role?: string; // admin | operator | staff | finance | user | agent
  division_id?: number | null;
};

const KEY_TOKEN = "access_token";
const KEY_USER_PRIMARY = "auth_user";
const KEY_USER_FALLBACK = "user";
export const AUTH_CHANGED_EVENT = "auth-changed";

function emitAuthChanged() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(AUTH_CHANGED_EVENT));
}

export function getAccessToken(): string {
  if (typeof window === "undefined") return "";
  return localStorage.getItem(KEY_TOKEN) || "";
}

export function setAccessToken(v: string) {
  if (typeof window === "undefined") return;
  if ((localStorage.getItem(KEY_TOKEN) || "") === v) return;
  localStorage.setItem(KEY_TOKEN, v);
  emitAuthChanged();
}

export function clearAccessToken() {
  if (typeof window === "undefined") return;
  if (!localStorage.getItem(KEY_TOKEN)) return;
  localStorage.removeItem(KEY_TOKEN);
  emitAuthChanged();
}

export function getUser(): UserSession | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(KEY_USER_PRIMARY) || localStorage.getItem(KEY_USER_FALLBACK);
    if (!raw) return null;
    return JSON.parse(raw) as UserSession;
  } catch {
    return null;
  }
}

export function setUser(u: UserSession) {
  if (typeof window === "undefined") return;
  const raw = JSON.stringify(u);
  const current = localStorage.getItem(KEY_USER_PRIMARY) || localStorage.getItem(KEY_USER_FALLBACK) || "";
  if (current === raw) return;
  localStorage.setItem(KEY_USER_PRIMARY, raw);
  localStorage.setItem(KEY_USER_FALLBACK, raw); // optional tapi bikin konsisten
  emitAuthChanged();
}

export function clearUser() {
  if (typeof window === "undefined") return;
  const hadPrimary = !!localStorage.getItem(KEY_USER_PRIMARY);
  const hadFallback = !!localStorage.getItem(KEY_USER_FALLBACK);
  if (!hadPrimary && !hadFallback) return;
  localStorage.removeItem(KEY_USER_PRIMARY);
  localStorage.removeItem(KEY_USER_FALLBACK);
  emitAuthChanged();
}

export function getRole(): "admin" | "operator" | "staff" | "finance" | "user" | "agent" {
  const u = getUser();
  const r = String(u?.role ?? "user").trim().toLowerCase();
  if (r === "admin" || r === "operator" || r === "staff" || r === "finance" || r === "agent") return r;
  return "user";
}
